import * as React from "react";
import PropTypes from 'prop-types';

const SvgSocialmediaBlog = props => {
  if (props.id !== "_svgsocialmediablog") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M20 4C11.163 4 4 11.163 4 20s7.163 16 16 16 16-7.163 16-16S28.837 4 20 4m-3.404 23.939a4.187 4.187 0 01-4.183-4.184V16.42a.922.922 0 111.846 0v7.334a2.34 2.34 0 002.337 2.337 2.34 2.34 0 002.337-2.337 2.34 2.34 0 00-2.337-2.338.923.923 0 010-1.845 4.187 4.187 0 014.184 4.183 4.188 4.188 0 01-4.184 4.184m6.367-5.307a.924.924 0 01-.924-.924 3.4 3.4 0 00-3.396-3.396.924.924 0 010-1.845c2.89 0 5.242 2.35 5.242 5.241 0 .51-.413.924-.922.924m4.01.501a.925.925 0 01-.925-.924c0-4.358-3.547-7.906-7.907-7.906a.923.923 0 010-1.845c5.38 0 9.754 4.374 9.754 9.751 0 .51-.414.924-.923.924" fill="#202020" /></svg>;
};

SvgSocialmediaBlog.displayName = "_svgsocialmediablog";
SvgSocialmediaBlog.propTypes = {
  id: PropTypes.string
};
SvgSocialmediaBlog.defaultProps = {
  id: ''
};
export default SvgSocialmediaBlog;